export enum Category {
  assignedID = 2,
  unAssignedID = 3,
  wearblesID = 1,
  lineSharedID = 4,
  emptyCategoryID = 0,
}
